import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";
import { cn } from "@repo/ui/lib/utils";
import { useRefinementList } from "react-instantsearch";
import { useNormalizedColors } from "@components/search/hooks/useNormalizedColors";
import { useLocale } from "next-intl";

export default function AlgoliaRefinementColor({ title }: { title: string }) {
  const { items, refine } = useRefinementList({
    attribute: "colorsNormalized",
    limit: 100,
  });
  const locale = useLocale().substring(0, 2) as "it" | "en";
  const colorsMap = useNormalizedColors();

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="item-1">
        <div className="py-[16px]">
          <AccordionTrigger className="max-md:text-base font-medium py-0 data-[state=open]:text-primary-magenta">
            {title}
          </AccordionTrigger>
          <AccordionContent className="mt-[20px] pb-0">
            <div className="flex flex-col items-start">
              {items
                .sort((a, b) =>
                  (colorsMap?.[a.value]?.[locale] ?? "").localeCompare(
                    colorsMap?.[b.value]?.[locale] ?? "",
                    locale,
                  ),
                )
                .map((item) => (
                  <button
                    key={item.value}
                    onClick={() => refine(item.value)}
                    className={cn("w-full py-2 flex gap-4 items-center", {
                      "font-bold": item.isRefined,
                    })}
                  >
                    <div
                      className={cn(
                        "ml-2 rounded-full h-[24px] w-[24px] border-secondary-gray4 border-[1.5px]",
                        {
                          "ring-2 ring-offset-[3px] ring-primary-magenta":
                            item.isRefined,
                        },
                      )}
                      style={{
                        backgroundColor: colorsMap?.[item.value]?.value,
                      }}
                    />
                    <span
                      className={cn("flex-1 text-left", {
                        "font-bold": item.isRefined,
                      })}
                    >
                      {colorsMap?.[item.value]?.[locale]}
                    </span>
                  </button>
                ))}
            </div>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
